// ═══ CarRegister "등록하고 출력" 플로우 — side effect 주입식 오케스트레이션 ═══
// 2026-04-21: CarRegister.js 557줄 복잡도 해소용 분리 (코드리뷰 권고 Step A).
//
// 플로우:
//   1) 필요 시 confirm 1회 (autodoc_print_confirm_shown sentinel)
//   2) 팝업창 gesture 보존 (window.open 'about:blank' 미리 열기)
//   3) reg() 호출 — { skipModal:true, _waitPrintType:<tab> }
//   4) 등록 성공 + docsReady에 target 포함 → 즉시 openPdf
//   5) 아닐 시 /docs 목록 polling (기본 200ms, 6s 타임아웃)
//   6) 타임아웃 시 window.confirm 블로킹 안내 — OK→rst+navigate, Cancel→폼 유지(🟢 신규)
//
// ctx 주입 필드:
//   API, authFetch, reg, rst, showToast, setPrinting
//   printing, saving, pDoc, carNo
//   windowRef: { open, confirm, navigate }
//   storage: { getItem, setItem }   // sessionStorage 대체
//   __timeoutMs, __pollInterval    // 테스트 전용 override
//
// 부수 버그 fix: failPopup 에서 rst() 호출을 confirm 응답 뒤로 이동.
//   기존: Cancel 눌러도 폼 이미 초기화 (사용자 데이터 분실 오인)
//   수정: OK 때만 rst, Cancel 은 폼 유지
function run(ctx) {
  if (!ctx) return;
  if (ctx.printing || ctx.saving) return;

  var wref = ctx.windowRef || window;
  var store = ctx.storage || (typeof sessionStorage !== 'undefined' ? sessionStorage : null);
  var timeoutMs = ctx.__timeoutMs != null ? ctx.__timeoutMs : 6000;
  var pollInterval = ctx.__pollInterval != null ? ctx.__pollInterval : 200;

  try {
    if (store && !store.getItem('autodoc_print_confirm_shown')) {
      if (!wref.confirm('출력 버튼은 차량을 등록한 뒤 생성된 PDF를 새 탭에서 엽니다.\n계속할까요?')) return;
      store.setItem('autodoc_print_confirm_shown', '1');
    }
  } catch(e) {}

  // 팝업 gesture 보존 — user click 체인 내에서 미리 열어두고 나중에 blob URL 대입
  var w = wref.open('about:blank', '_blank');
  if (!w) { ctx.showToast('팝업 차단을 해제해주세요', 'err'); return; }

  ctx.setPrinting(true);
  var currentTab = ctx.pDoc;
  var cno = ctx.carNo;

  var fail = function(msg) {
    try { w.close() } catch(e) {}
    ctx.setPrinting(false);
    ctx.showToast(msg || '출력 실패', 'err');
  };

  // PDF 타이밍 누락 안내 — OK 선택 시 rst + navigate, Cancel 시 폼 유지 (신규 동작)
  function failPopup() {
    try { w.close() } catch(e) {}
    ctx.setPrinting(false);
    var go = wref.confirm('등록은 완료되었습니다.\nPDF 생성이 지연되어 바로 열지 못했습니다.\n차량 목록으로 이동해 서류를 다운로드하시겠습니까?');
    if (go) {
      ctx.rst();
      try {
        if (wref.navigate) wref.navigate('/main/car-list');
        else wref.location.href = '/main/car-list';
      } catch(e) {}
    }
    // Cancel 선택 시 rst() 미호출 — 폼 데이터 유지 (부수 버그 fix)
  }

  function openPdf(carId, fileName) {
    ctx.authFetch(ctx.API + '/cars/' + carId + '/docs/' + fileName)
      .then(function(r) { return r.blob() })
      .then(function(blob) {
        var u = (typeof URL !== 'undefined' && URL.createObjectURL) ? URL.createObjectURL(blob) : '';
        w.location.href = u;
        ctx.setPrinting(false);
        ctx.rst();
      }).catch(function() { fail('PDF 로드 실패') });
  }

  ctx.reg(function(carId, regResp) {
    if (!carId) { fail('등록 실패'); return; }
    // 1순위: 서버가 우선 생성 완료 확정 (docsReady)
    var ready = regResp && regResp.docsReady && Array.isArray(regResp.docsReady)
      && regResp.docsReady.indexOf(currentTab) >= 0;
    if (ready) { openPdf(carId, currentTab + '_' + cno + '.pdf'); return; }

    // 2순위: /docs 목록 polling. 타임아웃 시 failPopup.
    var startT = Date.now();
    function pollFn() {
      ctx.authFetch(ctx.API + '/cars/' + carId + '/docs')
        .then(function(r) { return r.json() })
        .then(function(docs) {
          var found = (docs || []).find(function(dc) {
            return dc.fileName && dc.fileName.indexOf(currentTab + '_') === 0;
          });
          if (found) { openPdf(carId, found.fileName); return; }
          if (Date.now() - startT > timeoutMs) { failPopup(); return; }
          setTimeout(pollFn, pollInterval);
        }).catch(function() { failPopup() });
    }
    setTimeout(pollFn, pollInterval);
  }, { skipModal: true, _waitPrintType: currentTab });
}

module.exports = { run: run };
